import { isCanSetVerifyMechanismGames, isForceVerifyMechanismGames } from 'config/promoGameTypes';
import { useSelector } from 'react-redux';
import { parseJSON_ifParsable } from 'utils/objectManipulate';

export function useIsModuleNeedVerify() {
    const gameType = useSelector(s => s.promo.type);
    const { enableVerifyMechanism } = useSelector(s => s.settingPromo);
    return (
        isForceVerifyMechanismGames(gameType) ||
        (isCanSetVerifyMechanismGames(gameType) && Boolean(enableVerifyMechanism))
    );
}

export function useIsVerifyModuleCanGetParticipantWinner() {
    const gameType = useSelector(s => s.promo.type);
    const { enableVerifyMechanism } = useSelector(s => s.settingPromo);
    const currentEntryUUID = useSelector(s => s.userEntryState.currentEntryUUID);
    const lotteryParticipant = useSelector(s => s.lotteryParticipant);
    const lotteryInstant = useSelector(s => s.lotteryInstant);
    const isNeedVerifyModule =
        isForceVerifyMechanismGames(gameType) ||
        (isCanSetVerifyMechanismGames(gameType) && Boolean(enableVerifyMechanism));

    const canGetWinner = userGameResultRecords => {
        const currentGameResult =
            userGameResultRecords.find(r => r.uuid === currentEntryUUID) ?? {};
        const gameResultString = currentGameResult?.gameResult;

        const parseGameResult = parseJSON_ifParsable(gameResultString);

        const isMemoryGame = parseGameResult?.status !== undefined;
        const isMemoryGameChallengeFail = parseGameResult?.status === 0;
        const isQuizGame = parseGameResult?.gameResult?.wrongTotal !== undefined;
        const isQuizGameChallengeFail = Number(parseGameResult?.gameResult?.wrongTotal) !== 0;
        const isGameChallengeFail =
            (isMemoryGame && isMemoryGameChallengeFail) || (isQuizGame && isQuizGameChallengeFail);
        if (Boolean(currentGameResult.deletedAt)) return false;
        //兩個獎項都開條件 但遊戲失敗 所以不能getWinner
        else if (
            Boolean(lotteryParticipant?.TasksSetting?.uuid) &&
            Boolean(lotteryInstant?.TasksSetting?.uuid) &&
            isGameChallengeFail
        )
            return false;
        //只開 Instant獎項 但遊戲失敗 所以不能getWinner
        else if (
            Boolean(lotteryInstant?.TasksSetting?.uuid) &&
            !Boolean(lotteryParticipant?.uuid) &&
            isGameChallengeFail
        )
            return false;
        //只開 Participant 獎項 但遊戲失敗 所以不能getWinner
        else if (
            Boolean(lotteryParticipant?.TasksSetting?.uuid) &&
            !Boolean(lotteryInstant?.uuid) &&
            isGameChallengeFail
        )
            return false;
        else {
            if (
                isForceVerifyMechanismGames(gameType) ||
                (isCanSetVerifyMechanismGames(gameType) && Boolean(enableVerifyMechanism))
            ) {
                const { flow: { qualified } = {} } = currentGameResult;
                return Boolean(qualified);
            } else return true;
        }
    };
    // 因為 redux 更新時間點與此 hook 屬於同個 event loop ， 所以無法透過 redux 去取得最新的 userGameResultRecords
    return gameResultRecords => ({
        isNeedVerifyModule,
        canGetWinner: canGetWinner(gameResultRecords)
    });
}
